(function () {
  'use strict';

  function initInstance(config) {
    var root = document.getElementById('nz-locator-' + config.sectionId);
    if (!root) return;

    var countrySelect = root.querySelector('.nz-locator__select');
    var searchInput = root.querySelector('.nz-locator__input');
    var searchBtn = root.querySelector('.nz-locator__search-btn');
    var listEl = document.getElementById('nz-list-' + config.sectionId);
    var countEl = document.getElementById('nz-count-' + config.sectionId);
    var mapEl = document.getElementById('nz-map-' + config.sectionId);
    var mapFallback = document.getElementById('nz-map-fallback-' + config.sectionId);

    var state = {
      stores: [],
      country: config.defaultCountry || '',
      query: '',
      map: null,
      markers: [],
      infoWindow: null,
      mapsReady: false
    };

    fetch(config.dataUrl)
      .then(function (res) { return res.json(); })
      .then(function (data) {
        state.stores = data.filter(function (s) { return s.lat && s.lng; });
        buildCountryOptions();
        if (countrySelect.querySelector('option[value="' + cssEscape(state.country) + '"]')) {
          countrySelect.value = state.country;
        } else {
          state.country = '';
        }
        render();
        maybeLoadGoogleMaps();
      })
      .catch(function (err) {
        console.error('NZero store locator: could not load store data', err);
        listEl.innerHTML = '<p class="nz-locator__no-results">' + config.i18n.noResults + '</p>';
      });

    function cssEscape(value) {
      return (window.CSS && CSS.escape) ? CSS.escape(value) : value.replace(/["\\]/g, '\\$&');
    }

    function buildCountryOptions() {
      var countries = {};
      state.stores.forEach(function (s) {
        countries[s.country] = (countries[s.country] || 0) + 1;
      });
      var names = Object.keys(countries).sort(function (a, b) { return a.localeCompare(b); });
      names.forEach(function (name) {
        var opt = document.createElement('option');
        opt.value = name;
        opt.textContent = name + ' (' + countries[name] + ')';
        countrySelect.appendChild(opt);
      });
    }

    function getFiltered() {
      var q = state.query.trim().toLowerCase();
      return state.stores.filter(function (s) {
        if (state.country && s.country !== state.country) return false;
        if (!q) return true;
        var haystack = [s.city, s.postcode, s.name, s.address].join(' ').toLowerCase();
        return haystack.indexOf(q) !== -1;
      });
    }

    function render() {
      var results = getFiltered();
      var countText = config.i18n.resultsCount.replace('{count}', results.length);
      countEl.textContent = countText;
      listEl.innerHTML = '';

      if (!results.length) {
        var empty = document.createElement('p');
        empty.className = 'nz-locator__no-results';
        empty.textContent = config.i18n.noResults;
        listEl.appendChild(empty);
      } else {
        results.forEach(function (store) {
          listEl.appendChild(buildCard(store));
        });
      }

      renderMarkers(results);
    }

    function buildCard(store) {
      var card = document.createElement('div');
      card.className = 'nz-locator__card';
      card.dataset.id = store.id;

      var info = document.createElement('div');

      var name = document.createElement('p');
      name.className = 'nz-locator__card-name';
      name.textContent = store.name;
      info.appendChild(name);

      var address = document.createElement('p');
      address.className = 'nz-locator__card-address';
      address.textContent = store.address + ', ' + store.postcode + ' ' + store.city;
      info.appendChild(address);

      var meta = document.createElement('div');
      meta.className = 'nz-locator__card-meta';

      if (store.phone) {
        var phoneLine = document.createElement('div');
        var phoneLink = document.createElement('a');
        phoneLink.href = 'tel:' + store.phone.replace(/\s+/g, '');
        phoneLink.textContent = store.phone;
        phoneLine.appendChild(document.createTextNode(config.i18n.phone + ' '));
        phoneLine.appendChild(phoneLink);
        meta.appendChild(phoneLine);
      }
      if (store.email) {
        var emailLine = document.createElement('div');
        var emailLink = document.createElement('a');
        emailLink.href = 'mailto:' + store.email;
        emailLink.textContent = store.email;
        emailLine.appendChild(document.createTextNode(config.i18n.email + ' '));
        emailLine.appendChild(emailLink);
        meta.appendChild(emailLine);
      }
      if (store.web) {
        var webLine = document.createElement('div');
        var webHref = store.web.indexOf('http') === 0 ? store.web : 'https://' + store.web;
        var webLink = document.createElement('a');
        webLink.href = webHref;
        webLink.target = '_blank';
        webLink.rel = 'noopener';
        webLink.textContent = store.web;
        webLine.appendChild(document.createTextNode(config.i18n.web + ' '));
        webLine.appendChild(webLink);
        meta.appendChild(webLine);
      }
      info.appendChild(meta);
      card.appendChild(info);

      var viewBtn = document.createElement('button');
      viewBtn.type = 'button';
      viewBtn.className = 'nz-locator__view-btn';
      viewBtn.textContent = config.i18n.view;
      viewBtn.addEventListener('click', function () {
        focusStore(store);
      });
      card.appendChild(viewBtn);

      return card;
    }

    function focusStore(store) {
      Array.prototype.forEach.call(listEl.querySelectorAll('.nz-locator__card'), function (el) {
        el.classList.toggle('is-active', el.dataset.id === store.id);
      });
      if (state.map && state.mapsReady) {
        state.map.panTo({ lat: store.lat, lng: store.lng });
        state.map.setZoom(14);
        var marker = state.markers.filter(function (m) { return m.__storeId === store.id; })[0];
        if (marker) {
          openInfoWindow(marker, store);
        }
      }
    }

    function openInfoWindow(marker, store) {
      if (!state.infoWindow) return;
      var content = '<div class="nz-map-infowindow"><h4>' + escapeHtml(store.name) + '</h4>' +
        '<p>' + escapeHtml(store.address) + '<br>' + escapeHtml(store.postcode) + ' ' + escapeHtml(store.city) + '</p></div>';
      state.infoWindow.setContent(content);
      state.infoWindow.open({ anchor: marker, map: state.map });
    }

    function escapeHtml(str) {
      var div = document.createElement('div');
      div.textContent = str == null ? '' : str;
      return div.innerHTML;
    }

    function maybeLoadGoogleMaps() {
      if (!config.apiKey) {
        if (mapFallback) mapFallback.hidden = false;
        return;
      }
      if (window.__nzGoogleMapsLoading) {
        window.__nzGoogleMapsCallbacks = window.__nzGoogleMapsCallbacks || [];
        window.__nzGoogleMapsCallbacks.push(initMap);
        return;
      }
      if (window.google && window.google.maps) {
        initMap();
        return;
      }
      window.__nzGoogleMapsLoading = true;
      window.__nzGoogleMapsCallbacks = [initMap];
      window.__nzGoogleMapsInit = function () {
        window.__nzGoogleMapsCallbacks.forEach(function (cb) { cb(); });
      };
      var script = document.createElement('script');
      script.src = 'https://maps.googleapis.com/maps/api/js?key=' + encodeURIComponent(config.apiKey) + '&callback=__nzGoogleMapsInit';
      script.async = true;
      script.defer = true;
      script.onerror = function () {
        if (mapFallback) mapFallback.hidden = false;
      };
      document.head.appendChild(script);
    }

    function initMap() {
      if (!window.google || !window.google.maps || !mapEl) return;
      state.map = new google.maps.Map(mapEl, {
        center: { lat: 45, lng: 5 },
        zoom: 4
      });
      state.infoWindow = new google.maps.InfoWindow();
      state.mapsReady = true;
      renderMarkers(getFiltered());
    }

    function renderMarkers(results) {
      if (!state.mapsReady || !state.map) return;
      state.markers.forEach(function (m) { m.setMap(null); });
      state.markers = [];

      if (!results.length) return;

      var bounds = new google.maps.LatLngBounds();
      results.forEach(function (store) {
        var marker = new google.maps.Marker({
          position: { lat: store.lat, lng: store.lng },
          map: state.map,
          title: store.name
        });
        marker.__storeId = store.id;
        marker.addListener('click', function () {
          focusStore(store);
        });
        state.markers.push(marker);
        bounds.extend(marker.getPosition());
      });

      if (results.length === 1) {
        state.map.setCenter(bounds.getCenter());
        state.map.setZoom(13);
      } else {
        state.map.fitBounds(bounds, 60);
      }
    }

    countrySelect.addEventListener('change', function () {
      state.country = countrySelect.value;
      render();
    });

    searchBtn.addEventListener('click', function () {
      state.query = searchInput.value;
      render();
    });

    searchInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        state.query = searchInput.value;
        render();
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    (window.nzLocatorSections || []).forEach(initInstance);
  });
})();